export const MAX_TABLE_ENTRIES_PER_PAGE = 10;
